import { render, staticRenderFns } from "./SchoolVerticalNavMenu.vue?vue&type=template&id=5787b99c&scoped=true"
import script from "./SchoolVerticalNavMenu.vue?vue&type=script&lang=js"
export * from "./SchoolVerticalNavMenu.vue?vue&type=script&lang=js"
import style0 from "./SchoolVerticalNavMenu.vue?vue&type=style&index=0&id=5787b99c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5787b99c",
  null
  
)

export default component.exports